var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEpDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26 12L18 12V4L6 4L6 28L26 28L26 12ZM25.172 10L20 4.828V10H25.172ZM5 2L20 2L28 10L28 29C28 29.2652 27.8946 29.5196 27.7071 29.7071C27.5196 29.8946 27.2652 30 27 30L5 30C4.73478 30 4.48043 29.8946 4.29289 29.7071C4.10536 29.5196 4 29.2652 4 29L4 3C4 2.73478 4.10536 2.48043 4.29289 2.29289C4.48043 2.10536 4.73478 2 5 2ZM10 16L22 16V18L10 18V16ZM10 10L15 10V12H10L10 10ZM10 22L22 22V24L10 24V22Z",
    fill: "#5B6AF1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpDocument);
export default __webpack_public_path__ + "static/media/ep_document.3db8c4c9c2aba0bf14f237e9d6f71969.svg";
export { ForwardRef as ReactComponent };